import { createTermTagManager } from '../../utils/createTermTagManager';

export const hasProfitbaseBookingTagManager = createTermTagManager({
  jsonQueryKey: 'has_profitbase_booking',
  label: 'C онлайн-бронированием',
  id: 'hasProfitbaseBooking',
});
